export const FIRST_POST_READY_TTL_MS = 24 * 60 * 60 * 1000;
const VISUAL_UNREADY = new Set(['queued', 'processing', 'generating', 'visualizing', 'pending', 'failed']);

// Read the existing feed only: discovering an assistant-created first post must
// never arm the SPA onboarding widget's generation fallback.
export function recentReadyFirstPost({ content = [], userId, organizationId, brandId, now = Date.now() } = {}) {
  if (!userId || !organizationId || !brandId) return null;
  for (const row of content) {
    const item = row?.raw?.contentItem;
    if (!item?.id || item.userId !== userId || item.organizationId !== organizationId || item.brandProfileId !== brandId || item.source !== 'first_post') continue;
    if (item.archivedAt || !['ready', 'draft'].includes(row.status) || VISUAL_UNREADY.has(row.visualStatus ?? row.raw?.jobVisualStatus)) continue;
    if (item.format === 'image_post' && !row.imageUrl) continue;
    // Current writes use ISO/Z. Historical D1 timestamps without a zone are
    // UTC too; never interpret them in the browser's local time zone.
    const rawTime = String(item.createdAt || '');
    const utcTime = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(rawTime)
      ? `${rawTime.replace(' ', 'T')}Z` : rawTime;
    const createdAt = Date.parse(utcTime);
    if (!Number.isFinite(createdAt) || createdAt > now || now - createdAt >= FIRST_POST_READY_TTL_MS) continue;
    return { id: item.id, expiresAt: createdAt + FIRST_POST_READY_TTL_MS };
  }
  return null;
}

export function firstPostReadyKey(userId, postId) {
  return userId && postId ? `dathent.first-post.opened.${userId}.${postId}` : null;
}

export function markFirstPostOpened(userId, postId) {
  const key = firstPostReadyKey(userId, postId);
  if (!key) return;
  try { window.localStorage.setItem(key, '1'); } catch (_) { /* best effort */ }
}
